import { useCallback, useEffect } from 'react'

import api from 'common/api'
import { useUploadAPI } from './helpers'

const useLoadUploads = (onSuccess, onError) => {
  const API = useUploadAPI()
  const cb = useCallback(() => {
    api.get(API).then(onSuccess).catch(onError)
  }, [API, onSuccess, onError])
  useEffect(cb, [cb])
}
export default useLoadUploads
